/**
 * The hook components actually use — reads the current sound preference from the store so
 * `lib/sfx.ts` itself can stay a plain, store-agnostic module (easier to unit test).
 */
import { useCallback } from 'react';
import { usePreferencesStore } from '@/stores/preferences.store';
import { playSound, type SoundName } from './sfx';

export function useSfx() {
  const sound = usePreferencesStore((s) => s.sound);
  const soundVolume = usePreferencesStore((s) => s.soundVolume);

  return useCallback(
    (name: SoundName, options?: { force?: boolean; volumeScale?: number }) =>
      playSound(name, {
        enabled: sound,
        volume: soundVolume * (options?.volumeScale ?? 1),
        force: options?.force,
      }),
    [sound, soundVolume],
  );
}
